import { useQuery } from '@tanstack/react-query';
import { layoutVisibilityApi } from '../api/layoutVisibilityApi';

/**
 * Cte globalni viditelnost layoutu (pro diváky i pro plat / televizi).
 * Volane z admin settings (filtrovani nabidky), z public/board stranek (fallback).
 */
export const useLayoutVisibility = () =>
  useQuery({
    queryKey: ['layout-visibility'],
    queryFn: layoutVisibilityApi.get,
    staleTime: 5 * 60 * 1000,
  });
